import { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import dayjs from 'dayjs';

import { actions } from 'features/statistic';

import { convertFilters } from './convertFilters';
import { useDayFilters } from './data';

const useModel = () => {
  const dispatch = useDispatch();
  const daysFilterData = useDayFilters();

  const [values, setValues] = useState({
    from: new Date(dayjs().startOf('day').format('YYYY-MM-DD HH:mm')),
    to: new Date(dayjs().add(1, 'day').startOf('day').format('YYYY-MM-DD HH:mm')),
  });

  const [activeDay, setActiveDay] = useState('today');

  const onChangeFrom = useCallback(
    date => {
      setActiveDay('');
      setValues(ps => ({ ...ps, from: date }));
    },
    [],
  );

  const onChangeTo = useCallback(
    date => {
      setActiveDay('');
      setValues(ps => ({ ...ps, to: date }));
    },
    [],
  );

  const onChangeDay = useCallback(date => {
    setActiveDay(date.id ?? '');

    const to = new Date(dayjs().add(date.to, 'day').startOf('day').format('YYYY-MM-DD HH:mm'));

    const from = new Date(
      (date.id === 'month' ? dayjs().add(-1, 'month').add(1, 'day') : dayjs().add(date.from, 'day')).startOf('day').format('YYYY-MM-DD HH:mm'),
    );

    setValues(ps => ({ ...ps, to, from }));
  }, []);

  const onSubmit = useCallback(
    e => {
      e.preventDefault();
      dispatch(actions.getStatistic(convertFilters(values)));
    },
    [values, dispatch],
  );

  useEffect(() => {
    onSubmit(new Event('click'));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return useMemo(
    () => ({
      inputState: { values, onChangeFrom, onChangeTo, onChangeDay, onSubmit },
      outputState: { activeDay, daysFilterData },
    }),
    [values, onChangeFrom, onChangeTo, onChangeDay, daysFilterData, activeDay, onSubmit],
  );
};

export default useModel;
